import React from 'react';
import { getContext } from 'common';
import Styled from './styles';


export interface StepTextContainerProps {
  children: React.ReactNode | string;
}

/** Container to format step title and detail lines. All other props are passed to the root element. */
const StepTextContainer = React.forwardRef<HTMLElement, StepTextContainerProps>((props: StepTextContainerProps, ref) => getContext(({ RTL }) => {
  const { children, ...otherProps } = props;
  return (
    <Styled.StepTextContainer ref={ref} rtl={RTL} {...otherProps}>
      {children}
    </Styled.StepTextContainer>
  );
}));

StepTextContainer.displayName = 'StepTextContainer';

/* Exports */
export { StepTextContainer as default };
